/**
 * @generated SignedSource<<6216758aa709b5bcea81c82dd57c1ea5>>
 * @relayHash a3d07594d44de2b28667dd97e1e7d621
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e5ffdbb6328f8c2bb8811f81407657ef4c3176b7fe5f31381eb143a6ccff0d61

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { decomposedOriginalEstimateQuery } from './decomposedOriginalEstimateQuery.graphql';

const node: PreloadableConcreteRequest<decomposedOriginalEstimateQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "e5ffdbb6328f8c2bb8811f81407657ef4c3176b7fe5f31381eb143a6ccff0d61",
    "metadata": {},
    "name": "decomposedOriginalEstimateQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
